import { createFileRoute } from "@tanstack/react-router";
import AdminStockPictures from "@/pages/admin/AdminStockPictures";

export const Route = createFileRoute("/_adminLayout/admin/stock-pictures")({
  component: AdminStockPictures,
});
